<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-indent:0em; padding-top:100px">Reader feedback for <strong><em>The Aftermath: Book 1 – When Evil Strikes</em>:</strong></p><br/>
<p>I raced through this book, loved it.</p>
<p>I kept saying, ‘I’ll just read one more chapter.’</p>
<p>I’m really enjoying reading it.</p>
<p>I’ve read it and I love it.</p>
<p>I hope Book 2 is being written.</p>
<p>It’s a page turner, I love the short chapters.</p>
<p>It’s a good read.</p>
<p>Phew! Thank god for the twins.</p>
<p>I love the characters (and there’s a lot of them) especially, Chip.</p>
<p>I didn’t think that it would be my sort of thing, but it is, it really is.</p>
<p>A few spelling errors, but they don’t detract from the story.</p>
<p>It’s great, I think it’s really great.</p>
<p>Loved it, can’t wait for Book 2.</p>
<p>I’ve got 20 pages to go and I really like it. And I’m not a young adult!</p>
<p>I’m loving it.</p>
<p>I’m a third of the way through it and I really like it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1d3bb222